export default "__VITE_ASSET__CwtgbpNH__"